import { requests } from './baseServices'

export const InvoiceServices = {       
    sendViaEmail: (data) => requests.put(`api/invoices/send`, data),
    cancel: (id, isCreditNote) => requests.delete(`api/invoices/cancel/${id}/${isCreditNote}`),
    createCreditNote: (id) => requests.post(`api/invoices/credit/${id}`),
    changeDate: (dto) => requests.put(`api/invoices/date/`,dto),
};